import {HTTP} from '@/http-common';

const state = {
  loading: false,
  confirmation: {
    formConfirmation: 'Your referral has been submitted! For any questions, please contact %organization_name% directly.',
  }
}

const mutations = {
  SET_LOADING(state, data) {
    state.loading = data
  },
  SET_CONFIRMATION(state, {formConfirmation}) {
    state.confirmation = {formConfirmation}
  },
}

const getters = {
  getLoading: state => {
    return state.loading;
  },
  getConfirmation: state => {
    return state.confirmation;
  },
}

const actions = {
  fetchConfirmation ({commit}, {formId}) {
    commit('SET_LOADING', true);
    HTTP.get(`/referral/${formId}/confirmation/`).then(r => {
      commit('SET_LOADING', false);
      commit('SET_CONFIRMATION', r.data.data);
    })
  },
  saveConfirmation ({commit}, {formId, ...data}) {
    commit('SET_LOADING', true);
    HTTP.post(`/referral/${formId}/confirmation/`, data).then(r => {
      commit('SET_LOADING', false);
      commit('SET_CONFIRMATION', r.data.data);
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true,
}



// WEBPACK FOOTER //
// ./src/store/modules/referralConfirmation.js